import React, {Fragment} from 'react'

import * as track from '../../track/track'
import * as URLS from '../../urls'

import AutoLink from '../AutoLink'
import {Menu} from './Menu'

interface NavToggleContentProps {
  data: {
    href: string
    title: string
    toSpa: boolean
    dropdown?: []
    marketingText?: string
    openNewTab?: boolean
  }
}

export const NavToggleContent: React.FC<NavToggleContentProps> = ({
  data: {dropdown, href, title, toSpa, marketingText, openNewTab},
}) => {
  const handleLinkClick = () => {
    if (href === URLS.SHOWROOMS) {
      track.headerLocationsLinkClicked()
    }
    track.headerNavClicked(title, href)
  }

  const renderDropdownIcon = () =>
    dropdown && (
      <svg className="c-nav__link-chevron">
        <use xlinkHref="#icon-nav-chevron" />
      </svg>
    )

  return (
    <Fragment>
      {href ? (
        <AutoLink
          className="c-nav__link"
          isToSpa={toSpa}
          to={href}
          onClick={handleLinkClick}
          target={openNewTab ? '_blank' : undefined}
        >
          {title}
          {renderDropdownIcon()}
        </AutoLink>
      ) : (
        <span className="c-nav__link">
          {title}
          {renderDropdownIcon()}
        </span>
      )}
      {dropdown && <Menu items={dropdown} modifier="dropdown" menuHeader={marketingText} />}
    </Fragment>
  )
}
